import React from "react";

import Loader from "./SvgLoader";

const  SkeletonWithLoaders = () => {
  return (
    <>
      <Loader />
    </>
  );
};

export default  SkeletonWithLoaders;
